<template>
  <b-modal
        centered
        class="modal-padding"
        hide-footer
        v-model="isVisible"
        hide-header
        no-close-on-backdrop
        no-close-on-esc
      >
        <b-container fluid>
          <b-button
            @click="close"
            class="d-flex position-absolute close-btn"
          >
            <img
              class="close-icon"
              src="@/assets/icons/close_sidebar.svg"
              alt
            />
          </b-button>
          <b-row align-v="center" class="px-2 py-2">
            <b-col md="9" class="d-flex mb-2 subtext">
              <h4 class="font-md mt-2">
                {{ message }}
              </h4>
            </b-col>
          </b-row>
        </b-container>
      </b-modal>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      message: ""
    }
  },

  methods: {
    open(message) {
      this.isVisible = true
      this.message = message
    },

    close() {
      this.isVisible = false
      this.message = ""
    }
  }
}
</script>

<style>
  button.btn.close-btn {
    right: -2.5rem;
    top: -2rem;
    background: none;
  }
</style>